import React, { useEffect } from "react";
import styled from "styled-components";
import { TitleHeader } from "../../TitleHeader";
import { Link, useNavigate } from "react-router-dom";
import { colors } from "../../../utils/theme";
import SessionFisio from "./components/SessionFisio";
import AppoimentAvailability from "./components/AppoimentAvailability";
import { useDataContex } from "../../../hooks/Context/PatientProvider";
import InfoPatientFormContinuidad from "./InfoPatientForm";
import OrderFormPatientContinuidad from "./OrderFormPatient";
import InfoPatientForm from "../../CancelAppointment/ CurrentOrders/components/SesionPatient/InfoPatientForm";
import OrderFormPatient from "../../CancelAppointment/ CurrentOrders/components/SesionPatient/OrderFormPatient";

const Container = styled.div`
  width: 100%;
  margin-top: 2rem;

  .container_title {
    display: flex;
    background-color: ${colors.gris};
    padding: 1rem;
    justify-content: center;
    align-items: center;
    margin: 2rem 0;
  }

  .title2 {
    color: ${colors.primary};
    text-align: center;
    align-self: center;
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 600px) {
      font-size: 1.5rem;
    }
    @media (max-width: 375px) {
      font-size: 1.4rem;
    }
  }
`;

const Session = styled.div`
  width: 90%;
  background-color: #f9f9f9;
  margin: 0 auto;
  border-radius: 10px;
  box-shadow: 1px 1px 5px 1px #00000029;
`;

const ContainerOrder = styled.div`
  .paginator {
    padding: 1rem;
    display: flex;
    background-color: ${colors.gris};
    border-radius: 10px 10px 0 0;
    margin-bottom: 2rem;
    justify-content: space-between;
    align-items: center;
    @media (max-width: 550px) {
      flex-direction: column;
    }
  }

  .title1 {
    color: ${colors.primary};
    font-size: 1.5rem;
    font-weight: bold;
    @media (max-width: 768px) {
      font-size: 1.5rem;
    }
    @media (max-width: 500px) {
      text-align: center;
    }
  }

  .arrow {
    .bx {
      background-color: ${colors.blanco};
      font-size: 2rem;
      color: ${colors.primary};
      border-radius: 50%;
      cursor: pointer;
    }
  }
`;

export const SessionProgramaded = () => {
  const { patientContinuidadContex } = useDataContex();

  const navigate = useNavigate();


  useEffect(() => {
    if (!patientContinuidadContex) {
      navigate("/Continuidad");
    }
  }, [patientContinuidadContex, navigate]);

  const SesionFisio = {
    sesionProxima: patientContinuidadContex?.orders.numeroProximaSesion,
    sesionProgramable: patientContinuidadContex?.orders.sesionesProgramables,
    fisio: patientContinuidadContex?.orders.fisio,
  };

  return (
    <Container>
      <TitleHeader />
      <Session>
        <ContainerOrder>
          <div className="paginator">
            <Link className="arrow" to="/OrderContinuidad">
              <i className="bx bx-chevron-left"></i>
            </Link>
            <span className="title1">SESIONES A PROGRAMAR</span>
            <div></div>
          </div>

          <SessionFisio sesionFisio={SesionFisio} />

          <div className="container_title">
            <span className="title2">DISPONIBILIDAD DE CITA</span>
          </div>

          <AppoimentAvailability
            order={patientContinuidadContex?.orders.numeroDeOrden}
            numeroDocumento={patientContinuidadContex?.numeroDocumento}
          />

          {/* <Button onClick={handleButton}>
            <button>CONFIRMAR AGENDAMIENTO</button>
          </Button> */}

          <div className="container_title">
            <span className="title2">ORDEN MÉDICA</span>
          </div>

          <OrderFormPatientContinuidad />

          <div className="container_title">
            <span className="title2">INFORMACIÓN DEL PACIENTE</span>
          </div>
          <InfoPatientFormContinuidad />
        </ContainerOrder>
      </Session>
    </Container>
  );
};
